import React from 'react';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import { contact } from '../data/mock';

export default function TermsOfUsePage() {
  return (
    <>
      <SEO
        title="Terms of Use"
        description="Terms governing your access to and use of the Salihi Consulting Services website and the information made available through it."
        path="/terms-of-use"
      />
      <PageHero
        breadcrumb="Terms of Use"
        eyebrow="Legal"
        title="Terms of"
        italicTitle="Use."
        subtitle="These Terms of Use govern your access to and use of the Salihi Consulting Services website and the information made available through it."
      />

      <section className="py-16 sm:py-20 bg-[#0d2143]">
        <div className="max-w-[900px] mx-auto px-5 sm:px-6 lg:px-10">
          <article>
            <Block title="1. Acceptance of Terms">
              By accessing or using this website, you confirm that you have read,
              understood and agreed to be bound by these Terms of Use, together with
              our Privacy Policy and Cookies Policy. If you do not agree, please do
              not use the site.
            </Block>
            <Block title="2. About this website">
              This website is operated by Salihi Consulting Services. Content is
              provided for general informational purposes and to describe our
              capabilities. It is not intended to constitute, and should not be relied
              on as, professional, legal, tax, accounting, financial or investment
              advice. Engagement-specific advice is provided only under a written
              engagement letter.
            </Block>
            <Block title="3. Use of content">
              All content on this site — including text, graphics, logos, images, the
              Salihi Consulting brand, and underlying code — is owned by or licensed
              to Salihi Consulting Services and is protected by applicable
              intellectual-property laws. You may view, download and print pages from
              the site for personal, non-commercial reference. Any other reproduction,
              distribution, modification, public display or commercial use requires
              our prior written consent.
            </Block>
            <Block title="4. Acceptable use">
              You agree to use this site lawfully and respectfully. In particular, you
              must not: attempt to gain unauthorized access to any part of the site or
              our systems; introduce viruses or malicious code; misuse contact forms
              or send spam; misrepresent your identity; or use the site in any way
              that could damage, disable, overburden, or impair its operation.
            </Block>
            <Block title="5. Links to third-party sites">
              The site may contain links to third-party websites operated by parties
              we do not control. Such links are provided for convenience only. We do
              not endorse and are not responsible for the content, policies or
              practices of any third-party site.
            </Block>
            <Block title="6. No professional relationship">
              Submitting a contact form or otherwise interacting with this website
              does not, on its own, create a client relationship between you and
              Salihi Consulting Services. A client relationship is established only
              after we have agreed scope, fees and engagement terms in writing.
            </Block>
            <Block title="7. Disclaimer of warranties">
              The site and all content are provided on an “as is” and “as available”
              basis, without warranties of any kind, whether express or implied. We do
              not warrant that the site will be uninterrupted, error-free, secure, or
              free of viruses or other harmful elements.
            </Block>
            <Block title="8. Limitation of liability">
              To the maximum extent permitted by applicable law, Salihi Consulting
              Services, its partners, employees and affiliates shall not be liable for
              any direct, indirect, incidental, special, consequential or punitive
              damages arising out of or in connection with your access to, use of, or
              inability to use this website.
            </Block>
            <Block title="9. Indemnity">
              You agree to indemnify and hold harmless Salihi Consulting Services
              against any claims, losses, liabilities, damages, costs or expenses
              arising from your violation of these Terms of Use or your misuse of the
              site.
            </Block>
            <Block title="10. Governing law">
              These Terms of Use are governed by the laws applicable in the
              jurisdiction in which Salihi Consulting Services is established. Any
              dispute arising in connection with these Terms shall be resolved by
              good-faith discussion in the first instance and, failing that, in the
              competent courts of that jurisdiction.
            </Block>
            <Block title="11. Changes">
              We may update these Terms of Use from time to time to reflect operational,
              legal or regulatory changes. The revised version becomes effective when
              posted on this page. Continued use of the site after changes have been
              posted constitutes acceptance of the updated Terms.
            </Block>
            <Block title="12. Contact us">
              For any questions about these Terms, please contact us at{' '}
              <a href={`mailto:${contact.email}`} className="text-[#e8b863] underline underline-offset-2">{contact.email}</a>.
            </Block>
          </article>
        </div>
      </section>
    </>
  );
}

function Block({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="font-serif text-white font-medium text-[22px] sm:text-[26px] leading-tight tracking-tight mb-4">
        {title}
      </h2>
      <div className="text-white/78 text-[15px] leading-relaxed space-y-3">{children}</div>
    </section>
  );
}
